"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "John 'The Wall' Smith",
  position: "Goalkeeping Icon",
  bio: "A cornerstone of the 1970s golden era, recording over 200 clean sheets and leading the club to three consecutive titles.",
  expertise: "1970-1982",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/legend_john_smith.png"
}, {
  name: "Marco Rossi",
  position: "Midfield Maestro",
  bio: "The creative engine behind our most successful decade, Rossi's vision and technical brilliance remain unmatched in club history.",
  expertise: "1995-2005",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/legend_marco_rossi.png"
}];
export default function TheArchitectsOfSpeech() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234477" id="club-legends" className="bg-background text-foreground py-24 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-extrabold tracking-tighter uppercase mb-4">
            Club Legends
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Honouring the icons who defined the WT Birkalla spirit through decades of excellence and dedication.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, i) => <TeamMemberCard key={member.name} member={member} index={i} />)}
        </div>
      </div>
    </section>;
}
function TeamMemberCard({
  member,
  index
}: {
  member: typeof teamMembers[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const delay = index * 150;
  return <div data-index={index} ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`group relative overflow-hidden rounded-none aspect-[3/4] bg-card shadow-2xl border-t-2 border-primary transition-all duration-700 ease-out cursor-pointer ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      {}
      <img src={member.image} alt={`Portrait of ${member.name}`} className="absolute inset-0 w-full h-full object-cover grayscale contrast-125 transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/10 to-transparent opacity-90 group-hover:opacity-70 transition-opacity duration-500" />

      {}
      <Badge variant="default" className="absolute top-5 right-5 z-20 shadow-lg font-mono font-bold tracking-widest px-3 py-1 bg-primary text-primary-foreground rounded-none">
        {member.expertise}
      </Badge>

      {}
      <div className="absolute inset-x-0 bottom-0 bg-background/60 backdrop-blur-xl border-t border-primary/20 p-6 transition-transform duration-500 ease-in-out translate-y-[calc(100%-5.5rem)] group-hover:translate-y-0">
        <div className="h-[5.5rem] flex flex-col justify-start">
          <h3 className="font-default text-2xl font-extrabold text-foreground tracking-tighter uppercase">
            {member.name}
          </h3>
          <p className="text-primary font-mono text-sm font-bold mt-1 uppercase">{member.position}</p>
        </div>
        
        <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
          <div className="overflow-hidden">
            <p className="text-foreground/90 text-sm leading-relaxed pt-2 pb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 font-default">
              {member.bio}
            </p>
          </div>
        </div>
      </div>
    </div>;
}